$(function () {
  setTimeout(function () {
    $('.alert').fadeOut(500)
  }, 3000)
})
